import React from 'react';
import PropTypes from 'prop-types';
import { Input, Popup } from 'semantic-ui-react';
import './styles.less';

const FormInputField = ({
	input,
	type,
	placeholder,
	meta: { error, touched } = {},
	label,
	autoFocus,
	autoComplete,
	disabled,
	icon,
	dark,
	loading,
	min,
	max,
	timeWithSeconds,
	popupPosition,
	popupText,
	status,
	textPosition,
	isWithoutErrorText,
	unit,
}) => {
	return (
		<div
			className={`input_row ${dark ? 'dark' : ''} ${status || ''} ${error && touched ? 'error' : ''} ${
				textPosition ? `input_row_text_${textPosition}` : ''
			}`}
			data-testid="form-input-field"
		>
			{label && <label htmlFor={label}>{label}</label>}
			{popupText ? (
				<Popup
					position={popupPosition || 'top center'}
					content={<div className="input_row__popup-text">{popupText}</div>}
					trigger={
						/* eslint-disable react/jsx-wrap-multilines */
						<Input
							// eslint-disable-next-line react/jsx-props-no-spreading
							{...input}
							value={input.value}
							autoFocus={autoFocus}
							fluid
							type={type}
							placeholder={placeholder}
							id={label}
							autoComplete={autoComplete}
							disabled={disabled}
							icon={icon}
							loading={loading}
							min={min}
							max={max}
							step={type === 'time' && timeWithSeconds ? '1' : '0'}
							data-testid="form-input-field-component"
						/>
					}
					data-testid="form-input-field-popup"
				/>
			) : (
				<Input
					// eslint-disable-next-line react/jsx-props-no-spreading
					{...input}
					value={input.value}
					autoFocus={autoFocus}
					fluid
					type={type}
					placeholder={placeholder}
					id={label}
					autoComplete={autoComplete}
					disabled={disabled}
					icon={icon}
					loading={loading}
					min={min}
					max={max}
					step={type === 'time' && timeWithSeconds ? '1' : '0'}
					data-testid="form-input-field-component"
					label={unit ? { basic: true, content: unit } : undefined}
					labelPosition={unit ? 'right' : undefined}
				/>
			)}
			{error && touched && !isWithoutErrorText && <span className="validation_error">{error}</span>}
		</div>
	);
};

FormInputField.propTypes = {
	input: PropTypes.object,
	placeholder: PropTypes.string,
	meta: PropTypes.object,
	type: PropTypes.string,
	label: PropTypes.string,
	autoFocus: PropTypes.bool,
	autoComplete: PropTypes.oneOf(['off']),
	disabled: PropTypes.bool,
	icon: PropTypes.object,
	dark: PropTypes.bool,
	loading: PropTypes.bool,
	min: PropTypes.number,
	max: PropTypes.number,
	timeWithSeconds: PropTypes.bool,
	popupPosition: PropTypes.string,
	popupText: PropTypes.string,
	isWithAction: PropTypes.bool,
	status: PropTypes.string,
	textPosition: PropTypes.oneOf(['left', 'center', 'right', '']),
	isWithoutErrorText: PropTypes.bool,
	unit: PropTypes.string,
};

export { FormInputField };
